import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface AnswerSectionProps {
  title?: string;
  body: string;
}

/**
 * Prose answer rendered as the first section of every dashboard. Never
 * collapsed — the answer is the headline, always visible, and the only thing
 * a user needs to read in the concise-first default view.
 */
export function AnswerSection({ title, body }: AnswerSectionProps) {
  return (
    <section className="space-y-2 pb-2">
      {title ? (
        <h3 className="text-xl font-semibold tracking-tight text-foreground">{title}</h3>
      ) : null}
      <div className="prose prose-invert max-w-none text-base leading-relaxed text-foreground/95 [&_table]:block [&_table]:overflow-x-auto">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{body ?? ""}</ReactMarkdown>
      </div>
    </section>
  );
}
